import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CellPhonesContainer = styled.div`
  width: 30%;
  height: 50%;
  margin-right: 2rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  object-fit: contain;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const DataContainer = styled.div`
  width: 25%;
  height: 50%;
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 6rem;
    font-weight: 600;
    margin-bottom: 2rem;
  }

  h2 {
    font-size: 4rem;
    font-weight: 600;
  }

  h3 {
    margin-bottom: 2rem;
    font-size: 2rem;
    font-weight: 600;
  }

  p {
    font-size: 2rem;
    font-weight: 600;
  }
`;

export const LinksContainer = styled.div`
  background-color: #fade27;
  border-radius: 4px;
  padding: 1rem;
  display: flex;
  justify-content: space-around;
  align-items: center;

  a {
    width: 42%;
    height: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
    }
  }
`;
